import { action } from 'typesafe-actions'
import { PrivacyPolicyActionTypes } from './types'

// export const putProfileRequest = () =>
//   action(ProfileActionTypes.PUT_PROFILE_REQUEST)

export const fetchTermRequest = () =>
  // profileInfo: { profile: object }
  action(PrivacyPolicyActionTypes.TERM_REQUEST)
// , { profileInfo }

export const fetchTermSuccess = (term: object) =>
  action(PrivacyPolicyActionTypes.TERM_SUCCESS, { term })

export const fetchTermFail = (message: string) =>
  action(PrivacyPolicyActionTypes.TERM_FAIL, message)

export const fetchPrivacyPolicyRequest = () =>
  action(PrivacyPolicyActionTypes.PRIVACY_POLICY_REQUEST)

export const fetchPrivacyPolicySuccess = (privacyPolicy: object) =>
  action(PrivacyPolicyActionTypes.PRIVACY_POLICY_SUCCESS, { privacyPolicy })

export const fetchPrivacyPolicyFail = (message: string) =>
  action(PrivacyPolicyActionTypes.PRIVACY_POLICY_FAIL, message)
